import styled, { css } from 'styled-components';

import { useClickAttachment } from 'hooks/useClickAttachment';
import { SummaryAttachment } from 'models/aiArtifacts/Summary';

type CitationBadgeProps = {
  attachment: SummaryAttachment;
  size?: number;
  // using a negative because most components will want to show the hover effect
  hideHoverEffect?: boolean;
  clickable?: boolean;
  onClick?: () => void;
};

export default function CitationBadge({
  attachment,
  size = 16,
  hideHoverEffect = false,
  clickable = true,
  onClick,
}: CitationBadgeProps) {
  const openAttachment = useClickAttachment(attachment.attachmentId);

  const handleClick = onClick ?? openAttachment;

  return (
    <StyledCitationBadge
      size={size}
      hoverable={!hideHoverEffect}
      clickable={clickable || !!onClick}
      onClick={clickable || !!onClick ? handleClick : undefined}
      title={!hideHoverEffect ? attachment.filename : undefined}>
      {attachment.displayId}
    </StyledCitationBadge>
  );
}

const StyledCitationBadge = styled.span<{ size: number; hoverable: boolean; clickable: boolean }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  background: rgba(94, 66, 225, 0.2);
  color: #3e2d6e;
  line-height: 8px;
  font-size: 8px;
  font-weight: 700;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  ${({ hoverable }) =>
    hoverable &&
    css`
      &:hover {
        border: 0.5px solid #3e2d6e;
      }
    `}
`;
